import {SubmissionDto} from '../../scaffold';

export const enterpriseMentorFields = [
  {name: 'enterpriseMentorName', label: '企业导师姓名'},
  {name: 'enterpriseMentorEmail', label: '企业导师邮箱'},
  {name: 'enterpriseMentorTelephone', label: '企业导师联系电话'},
  {name: 'enterpriseMentorOrganization', label: '企业导师所在单位'},
  {name: 'enterpriseMentorOrganizationCreditCode', label: '企业导师所在单位统一社会信用代码'},
] as const;

export const thesisTypes = ['专题研究类', '工程应用类', '工程案例分析类'];

export function requiresAdditionalDetails(termName?: string | null): boolean {
  return !!termName && /^[0-9]{4}/.test(termName) && Number(termName.slice(0, 4)) >= 2027;
}

export function showAdditionalDetails(submission: SubmissionDto): boolean {
  return requiresAdditionalDetails(submission.term?.name) || !!submission.thesisType || enterpriseMentorFields.some(field => !!submission[field.name]);
}
